import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { LoaderService } from 'src/app/core/interceptors/loader/loader.service';
import { MsalService } from '@azure/msal-angular';
import { EnvService } from 'src/app/core/services/env.service';
import { DialogService } from 'src/app/shared/dialog/confirm-dialog/dialog.service';
import { NotificationService } from 'src/app/shared/notification/notification.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivityNotificationService } from 'src/app/core/services/activity-notification/activity-notification.service';
import { PermissionsService } from 'src/app/core/services/common/permissions.service';
import { AESEncryptDecryptService } from 'src/app/core/services/common/encryption/aesencrypt-decrypt.service';
import { ActivityNotification } from 'src/app/shared/enum/activityNotification';
import { LogoutString } from 'src/app/shared/enum/logoutString';
import { MatDialog } from '@angular/material/dialog';
import { TermsDialogComponent } from '../../accept-terms/terms/terms-dialog.component';
import { ListNotificationComponent } from '../../activity-notification/list-notification/list-notification.component';
import { ICIComponentDeploymentManagement } from 'src/app/shared/enum/iciComponentDeployment';
import { IdnConfigurationService } from 'src/app/core/services/common/idn-configuration.service';
import { filter } from 'rxjs';
import { InstanceService } from 'src/app/core/services/instance-management/instance.service';

const EMPTY_NOTIFICATION_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="52" height="52" viewBox="0 0 52 52">
<image id="_2950678" data-name="2950678" width="52" height="52" opacity="0.24" xlink:href="data:image/png;base64,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"/>
</svg>
`;
const SKU_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="16.788" height="20.678" viewBox="0 0 16.788 20.678">
  <path id="Union_2" data-name="Union 2" d="M0,17.106V9.85l7.771,3.162v7.666Zm9.08-4.095L16.788,9.8v7.211L9.08,20.632ZM1.225,8.8,6.082,6.915v3.23h4.646V6.915L15.542,8.8,8.426,11.761Zm6.124-.091V3H6.208L8.383,0l2.154,3H9.355v5.71Z" fill="#6332a4"/>
</svg>
`;

const DEPLOYMENT_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="18.192" viewBox="0 0 16.224 18.192">
  <path id="Subtraction_1" data-name="Subtraction 1" d="M15.628,19.132H9.878l.031-7.04,1.633,2.982h4.086v4.057Zm-6.582,0H3.331V15.074H7.555l1.521-2.967-.03,7.024ZM17.6,14.206H12.024L9.935,10.391h5.854L17.6,14.2Zm-10.548,0H1.429l-.051-.024,1.872-3.791H9.012L7.055,14.205Zm5.591-4.683H6.468a9.211,9.211,0,0,1-.206-2.979H7.9a1.667,1.667,0,0,0,3.262,0h1.688a9.072,9.072,0,0,1-.21,2.978ZM9.536,7a.889.889,0,1,1,.851-.888A.871.871,0,0,1,9.536,7ZM7.9,5.676H6.4A8.066,8.066,0,0,1,9.528.941a8.065,8.065,0,0,1,3.186,4.734H11.167a1.667,1.667,0,0,0-3.262,0Z" transform="translate(-1.379 -0.94)" fill="#6332a4"/>
</svg>

`;

const ADMIN_ICON = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m640-120-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-29 72-24 143t48 135H80Zm600-80q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Z"/></svg>`;

const UPGRADE_ICON=`<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m438-338 226-226-57-57-169 169-84-84-57 57 141 141Zm42 258q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Z"/></svg>`;

export const INSTANCE_OPERATIONS = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M600-120v-120H440v-400h-80v120H80v-320h280v120h240v-120h280v320H600v-120h-80v320h80v-120h280v320H600Z"/></svg>`;
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  public iciComponentDeploymentEnum = ICIComponentDeploymentManagement;
  loading$ = this.loaderService.loading$;
  _userName: any;
  userAvatar = localStorage.getItem('userAvatar');
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date;
  notificationList: any;
  userID: any;
  badgeCount: any = null;
  isuserLoggedin: boolean = false;
  toggleMenuContainer: any = { 
    "administration": false,
    "developmentandutilities": false,
    "instanceoperations": false,
    "sku-management": false,
    "upgrade": false
  };
  adminPermission :any =  [];
  requiredAdminPermission:any = [
    'ViewRole','ViewPartner','ViewCustomer','ViewUser'
  ]
  upgradePermission : any = [];
  requiredUpgradePermission:any = [
    'UpgradeMultiTenantPOD', 'ViewMultiTenantPOD'
  ]
  developmentandutilitiesPermission:any = [];
  requireddevelopmentandutilitiesPermission : any = [
    'ViewSDK','ViewExtension','ViewCertification'
  ]
  instanceOperationsPermission : any =[];
  requiredInstanceOperationsPermission : any = [
    'ViewInstance', 'ViewDeployment'
  ]
  toggleSubMenuContainer = false;
  hasSupportAccess: boolean = false;
  innerWidth: number = 1200;
  activeNavLink = localStorage.getItem('activeNavLink');
  isToggleMenuContainer = localStorage.getItem('toggleMenuContainer');
  acceptedAt: any;
  supportLink: any;
  viewPublicPage: any;
  viewPodUpgradeFeature:any;
  public notificationEnum = ActivityNotification;
  public logoutEnum = LogoutString;
  urlSafe: any;
  url: string = "https://developer-help.icertis.com/idn-1-x-release-notes/";
  whatsNew: any;
  loadEventProcessed:any = false;
  isViewSDK: boolean = false;
  removeWBReleasebanner: any;
  count: any = 0;
  approvalAccessToDebuggingUtilitiesProd:boolean=false;
  approvalAccessHangfire: boolean = false
  isApproveRejectInstance: boolean = false;
  isApproveRejectDeployment: boolean = false;
  isApproveRejectCertification: boolean = false;
  userEmail: any = '';
  userRole: any = '';
  Username(): string {
    this._userName =
      localStorage.getItem('username') != null
        ? localStorage.getItem('username')
        : '';
    return this._userName;
  }
  releaseLink:boolean =true;
  isAboutDrawer: any = false;
  constructor(
    private titleService: Title,
    private router: Router,
    public loaderService: LoaderService,
    private msalService: MsalService,
    public _location: Location,
    private elementRef: ElementRef,
    private env: EnvService,
    private MatDialog: MatDialog,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private activityNotifyService: ActivityNotificationService,
    private permssionService: PermissionsService,
    iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private permissionService: PermissionsService,
    private _AESEncryptDecryptService: AESEncryptDecryptService,
    private cd: ChangeDetectorRef,
    private idnConfiguration:IdnConfigurationService,
    private instanceService:InstanceService
  ) {
    iconRegistry.addSvgIconLiteral(
      'empty_notification_icon',
      sanitizer.bypassSecurityTrustHtml(EMPTY_NOTIFICATION_ICON)
    );
    iconRegistry.addSvgIconLiteral(
      'sku',
      sanitizer.bypassSecurityTrustHtml(SKU_ICON)
    );
    iconRegistry.addSvgIconLiteral(
      'deployment',
      sanitizer.bypassSecurityTrustHtml(DEPLOYMENT_ICON)
    );
    iconRegistry.addSvgIconLiteral(
      'admin',
      sanitizer.bypassSecurityTrustHtml(ADMIN_ICON)
    );
    iconRegistry.addSvgIconLiteral(
      'upgrade',
      sanitizer.bypassSecurityTrustHtml(UPGRADE_ICON)
    );
    iconRegistry.addSvgIconLiteral(
      'instance_operations',
      sanitizer.bypassSecurityTrustHtml(INSTANCE_OPERATIONS)
    );
    
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.elementRef.nativeElement
          .getElementsByClassName('pss-main-content')[0]
          .removeAttribute('id');
      }
      if (event instanceof NavigationEnd) {
        let self = this;
        setTimeout(function () {
          if (
            self.elementRef.nativeElement.getElementsByClassName(
              'pss-form-button-wrapper'
            ).length > 0
          ) {
            self.elementRef.nativeElement
              .getElementsByClassName('pss-main-content')[0]
              .setAttribute('id', 'main-container-height');
          } else {
            self.elementRef.nativeElement
              .getElementsByClassName('pss-main-content')[0]
              .removeAttribute('id');
          }
        });
      }
    });
  }

  @HostListener('window:resize') onWindowResize() {
    this.innerWidth = window.innerWidth;
    this.getInitialWindowSize(this.innerWidth);
  }

  getInitialWindowSize(winSize: number) {
    if (winSize <= this.env.minBreakpoint) {
      this.isOpened = false;
    } else {
      this.isOpened = true;
    }
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // Handle route change here, e.g., update navbar
        let navLink =event.url;
        let link = navLink.includes('/')? navLink.split('/')[2] : navLink;
        for(let item in this.toggleMenuContainer){
          if(item == link){
            this.toggleMenuContainer[item]= true;
          } else{
            this.toggleMenuContainer[item]= false;
          }
        }
        localStorage.setItem('toggleMenuContainer', JSON.stringify(this.toggleMenuContainer));
      });
    let linkData = localStorage.getItem("WBReleaseLink");
    this.releaseLink = linkData == 'true'? true: false;
    this.isViewSDK = this.permssionService.getPermission('ViewSDK');
    this.userEmail = this.permissionService.getuserEmail();
    this.approvalAccessToDebuggingUtilitiesProd = this.permissionService.getPermission('ApprovalAccessToDebuggingUtilities-Prod');
    this.approvalAccessHangfire = this.permissionService.getPermission('ApprovalAccessToHangfire');
    this.isApproveRejectInstance = this.permissionService.getPermission('ApproveInstance') || this.permissionService.getPermission('RejectInstance');
    this.isApproveRejectDeployment = this.permissionService.getPermission('ApproveDeployment') || this.permissionService.getPermission('RejectDeployment');
    this.isApproveRejectCertification = this.permissionService.getPermission("ApproveCertification") || this.permissionService.getPermission("RejectCertification");
    let featuresTobeDisabled: any = localStorage.getItem(
      'featuresTobeDisabled'
    );
    this.removeWBReleasebanner = featuresTobeDisabled?.includes('WBReleaseLink')
      ? true
      : false;
   this.adminPermission =  this.requiredAdminPermission.map((permission:any)=>{
      return this.permssionService.getPermission(permission);
    });
    this.upgradePermission = this.requiredUpgradePermission.map((permission:any)=>{
      return this.permssionService.getPermission(permission);
    });
    this.developmentandutilitiesPermission = this.requireddevelopmentandutilitiesPermission.map((permission:any)=>{
      return this.permssionService.getPermission(permission);
    });
    this.instanceOperationsPermission = this.requiredInstanceOperationsPermission.map((permission:any)=>{
      return this.permssionService.getPermission(permission);
    });
    if(this.isToggleMenuContainer){
      this.toggleMenuContainer = JSON.parse(this.isToggleMenuContainer);
      let currentPage = this.router.url?.split('/')[2];
      for(let item in this.toggleMenuContainer){
        if(item == currentPage){
          this.toggleMenuContainer[item]= true;
        } else{
          this.toggleMenuContainer[item]= false;
        }
      }
    }    
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.instanceService.recieveRoleNameData().subscribe((data:any)=>{
      if(data){
        this.userRole = data;
      } else {
       this.instanceService.getIdnInsights().subscribe((data:any) => {
        let result = data?.body;
        if(result){
          this.userRole = result?.roleName;
        }
      });
      }
    })
    this.idnConfiguration.onWhatsNewFeatue().subscribe((resp)=>{
      this.whatsNew = resp;
      this.loaderService.show();
    })
    this.permissionService.GetIDNConfiguration().subscribe((resp) => {
      if (resp) {
        this.supportLink = resp.body.content.idnSupport;
        this.viewPublicPage = resp.body.content.enablePublicAppHostingFeature;
        localStorage.setItem(
          'enablePublicAppHostingFeature',
          this.viewPublicPage
        );
        if (this.viewPublicPage == true) {
          if (this.permssionService.getPermission('CreateSolutionPackage')) {
            this.menuItems.push({
              label: 'Public App Hosting',
              path: 'web-app-management',
              icon: 'group_work',
              id: 'web-app',
              isactive:
                this.activeNavLink == 'web-app-management' ? true : false,
            });
          }
        }
      }
    });
    if(this.approvalAccessToDebuggingUtilitiesProd || this.approvalAccessHangfire || this.isApproveRejectInstance || this.isApproveRejectDeployment || this.isApproveRejectCertification){
      this.getPendingCount();
      this.instanceService.getUpdatedApprovalCountEvent$.subscribe((res:any)=>{
        this.getPendingCount();
      })
    }
    this.hasSupportAccess = true;
    this.permissionService.getPermissionListForUser().subscribe((res) => {
      if (res.body != undefined || res.body != null) {
        let authuserpermissions = res.body;
        localStorage.setItem(
          'authenticatedUser',
          this._AESEncryptDecryptService.encrypt(
            JSON.stringify(authuserpermissions)
          )
        );
      }
    });

    this.titleService.setTitle('Home | ALM Studio');
    this.innerWidth = window.innerWidth;
    this.getInitialWindowSize(this.innerWidth);    
    if (this.msalService.instance.getActiveAccount() != null) {
      if (!(this.permissionService.getPermission('UpgradeMultiTenantPOD') && !this.permissionService.getPermission('PreviewMultiTenantPODUpgrade'))){
      this.menuItems = [
        {
          label: 'Home',
          path: 'resources',
          icon: 'home',
          id: 'home',
          isactive: this.activeNavLink == 'resources' ? true : false,
        },
      ];
    }

    if(this.approvalAccessToDebuggingUtilitiesProd || this.approvalAccessHangfire || this.isApproveRejectInstance || this.isApproveRejectDeployment || this.isApproveRejectCertification){
      this.menuItems.push({
        label: 'My Tasks',
        path: 'actionables/my-approvals',
        icon: 'fact_check',
        id: '',
        isactive: this.activeNavLink == 'actionables/my-approvals'? true : false,
      })
    }

    if(this.adminPermission.some((value:any)=>{ return value})){
    this.menuItems.push({
      label: 'Administer',
      path: 'administration',
      icon: 'manage_accounts',
      id: 'admin',
      isactive: false,
      subMenu:  
      [
        this.permssionService.getPermission('ViewRole')?
        {
          label: 'Roles',
          path: 'administration/role-management',
          id: '',
          isactive: this.activeNavLink == 'administration/role-management' ? true : false,
        } : '',  
        this.permssionService.getPermission('ViewPartner')?  
        {
          label: 'Partners',
          path: 'administration/partner-management',
          id: '',
          isactive: this.activeNavLink == 'administration/partner-management' ? true : false,
        } : '',
        this.permssionService.getPermission('ViewCustomer')?
        {
          label: 'Customers',
          path: 'administration/customer-management',
          id: '',
          isactive: this.activeNavLink == 'administration/customer-management' ? true : false,
        } : '',
        this.permssionService.getPermission('ViewUser')?
        {
          label: 'Users',
          path: 'administration/user-management',
          id: '',
          isactive: this.activeNavLink == 'administration/user-management' ? true : false,
        } : '',
      ]
    });
    }
   
    if(this.upgradePermission.some((value:any)=>{ return value})){
      this.viewPodUpgradeFeature =  localStorage.getItem('enableMTPodUpgradeCalendarFeature');
      this.menuItems.push({
        label: 'Upgrade',
        path: 'upgrade',
        id: 'upgd',
        icon: 'verified_user',
        isactive: false,
        subMenu: [
           this.permssionService.getPermission('UpgradeMultiTenantPOD')?
          {
            label: 'Calendar',
            path: 'upgrade/pod-upgrade',
            id: '',
            isactive: this.activeNavLink == 'upgrade/pod-upgrade' ? true : false,
          } : '',
          this.permssionService.getPermission('ViewMultiTenantPOD')?
          {
            label: 'Dashboard',
            path: 'upgrade/multi-tenantPod-management',
            id: '',
            isactive: this.activeNavLink == 'upgrade/multi-tenantPod-management' ? true : false,
          }:'',
        ],
      });
    }

    if(this.developmentandutilitiesPermission.some((value:any)=>{ return value})){
      this.menuItems.push({
        label: 'Develop',
        path: 'developmentandutilities',
        id: 'dev',
        icon: 'code',
        isactive: false,
        subMenu: [
              this.permssionService.getPermission('ViewSDK')?
              {
              label: 'Workbench',
              path: 'developmentandutilities/workbench-management',
              id: '',
              isactive:
                this.activeNavLink == 'developmentandutilities/workbench-management' ? true : false,
            }:'',
            this.permssionService.getPermission('ViewExtension')?
            {
              label: 'Extensions',
              path: 'developmentandutilities/extension-management',
              id: '',
              isactive: this.activeNavLink == 'developmentandutilities/extension-management' ? true : false,
            }:'',
            this.permssionService.getPermission('ViewCertification')?
            {
              label: 'Certifications',
              path: 'developmentandutilities/certification-request',
              id: '',
              isactive:
                this.activeNavLink == 'developmentandutilities/certification-request' ? true : false,
            }:'',
        ],
      });
    }
     
    if(this.instanceOperationsPermission.some((value:any)=>{ return value})){
      this.menuItems.push({
        label: 'Implement & Support',
        path: 'instanceoperations',
        icon: 'account_tree',
        id: 'inst_oper',
        isactive: false,
        subMenu: [
          this.permssionService.getPermission('ViewInstance')?
          {
            label: 'Instances',
            path: 'instanceoperations/instance-requests',
            id: '',
            isactive: this.activeNavLink == 'instanceoperations/instance-requests' ? true : false,
          } : '',
          this.permssionService.getPermission('ViewDeployment')?
          {
            label: 'Deployments',
            path: 'instanceoperations/deployment',
            id: '',
            isactive: this.activeNavLink == 'instanceoperations/deployment' ? true : false,
          }:'',
        ],
      });
    }
      
      var portalAdmin = this.permissionService.hasGlobalDataAccess();
      if (this.permssionService.getPermission('ViewSKU') || this.permssionService.getPermission('AddInstance')) {
        if (portalAdmin) {
          this.menuItems.push({
            label: 'SKUs',
            path: 'sku-management',
            id: 'sku_2',
            icon: 'unarchive',
            isactive: false,
            subMenu: [this.permssionService.getPermission('ViewSKU')?
              {
                label: 'Product Catalog',
                path: 'sku-management/sku-master',
                icon: 'sku',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/sku-master'
                    ? true
                    : false,
              }:'',
              this.permssionService.getPermission('ViewSKU')?
              {
                label: 'Requests',
                path: 'sku-management/release-request',
                icon: 'sku',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/release-request'
                    ? true
                    : false,
              }:'',
              this.permssionService.getPermission('ViewSKU')?
              {
                label: 'Deployments',
                path: 'sku-management/sku-deployments',
                icon: 'sku',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/sku-deployments'
                    ? true
                    : false,
              }:'',
              this.permssionService.getPermission('AddInstance')?
              {
                label: 'Direct Deploy',
                path: 'sku-management/ici-component-deployment',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/ici-component-deployment' ? true : false,
              }:'',
               
            ],
          });
        } else {
          this.menuItems.push({
            label: 'SKUs',
            path: 'sku-management',
            icon: 'unarchive',
            isactive: false,
            id: 'sku_1',
            subMenu: [this.permssionService.getPermission('ViewSKU')?
              {
                label: 'Product Catalog',
                path: 'sku-management/sku-master',
                icon: 'sku',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/sku-master'
                    ? true
                    : false,
              }:'',
              this.permssionService.getPermission('ViewSKU')?
              {
                label: 'Requests',
                path: 'sku-management/release-request',
                icon: 'sku',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/release-request'
                    ? true
                    : false,
              }:'',
              this.permssionService.getPermission('AddInstance')?
              {
                label: 'Direct Deploy',
                path: 'sku-management/ici-component-deployment',
                id: '',
                isactive:
                  this.activeNavLink == 'sku-management/ici-component-deployment' ? true : false,
              }:'',
            ],
          });
        }
      }
    }
    
    this.userNotification();
  }

  getPendingCount(){
    this.instanceService.getToolsAccessRequestApprovalPendingCount().subscribe((res:any)=>{
      if(res){
        this.count = res.body.content;
      }
    })
  }

  @ViewChild('sidenav') public sidenav: any;
  navLink: string = '';
  isOpened: boolean = false;
  toggleTooltip: string = 'Collapse';
  menuItems: any = [];
  userNotificationData: any = [];

  logout(): void {
    this.dialogService
      .confirmDialog({
        title: this.logoutEnum.logout_dialog_heading,
        module: 'logout',
        message: this.logoutEnum.logout_dialog_body,
        confirmText: this.logoutEnum.logout_dialog_primary_btn,
        cancelText: this.logoutEnum.logout_dialog_secondary_btn,
      })
      .subscribe((res) => {
        if (res) {
          localStorage.setItem('loggedin', 'false');
          localStorage.removeItem('authenticatedUser');
          localStorage.removeItem('activeNavLink');
          localStorage.removeItem('isToggleMenuContainer');
          document.cookie = 'HangFireCookie=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
          let ss = this.msalService.instance.getActiveAccount()?.homeAccountId;
          let loginhint =
            this.msalService.instance.getActiveAccount()?.idTokenClaims
              ?.login_hint;
          const currentAccount = this.msalService.instance.getAccountByHomeId(
            ss!
          );
          if (currentAccount != null) {
            this.msalService.instance.logoutRedirect({
              account: currentAccount,
              idTokenHint: loginhint,
              logoutHint: loginhint,
            });
            localStorage.clear();
          } else {
            this.msalService.instance.logoutRedirect();
          }
        }
      });
  }

  toggleMenu(): void {
    if (
      this.elementRef.nativeElement.getElementsByClassName(
        'pss-form-button-wrapper'
      ).length > 0
    ) {
      this.elementRef.nativeElement.setAttribute('id', 'stickyFooterFull');
    } else {
      this.elementRef.nativeElement.removeAttribute('id');
    }
    this.isOpened = !this.isOpened;
    if (this.isOpened) {
      this.elementRef.nativeElement.removeAttribute('id');
      this.sidenav.toggle();
      this.toggleTooltip = 'Collapse';
    } else {
      this.sidenav.toggle();
      this.toggleTooltip = 'Expand';
    }
  }

  navigateItem(navLink: any): void {
    let link = navLink.includes('/')? navLink.split('/')[0] : navLink;
    let multiLinkArray = ['sku-management', 'administration', 'upgrade', 'developmentandutilities', 'instanceoperations']
    if (!multiLinkArray.includes(link)) {
      multiLinkArray.forEach((menu:any)=>{
        this.toggleMenuContainer[menu]= false;
      })
      localStorage.setItem('toggleMenuContainer', JSON.stringify(this.toggleMenuContainer));
    }
    let navlink = 'home';
    if (navLink != undefined) {
      if (navLink == 'home') {
        navLink = 'home';
      } else {
        if(this.permissionService.getPermission('UpgradeMultiTenantPOD') && !this.permissionService.getPermission('PreviewMultiTenantPODUpgrade')){
          navLink = 'upgrade/pod-upgrade';
        }
        navLink = 'home/' + navLink;
      }
      /*  ------------------------------------------------------------
          to meet partial reload when user is deep on the pagination
          and when click on Sidenavigation link Grid List will display
          items from page 1 (as asked by Nikhil Kulkarni)
          ------------------------------------------------------------
      */
      this.router
        .navigateByUrl(navlink, { skipLocationChange: true })
        .then(() => {
          this.router.navigate([navLink]);
          this.innerWidth = window.innerWidth;
          this.getInitialWindowSize(this.innerWidth);
        });
    }
  }
  // Clear all Notification
  clearNotification() {
    this.dialogService
      .confirmDialog({
        title: this.notificationEnum.notification_dialog_heading,
        module: 'notification',
        message: this.notificationEnum.notification_dialog_body,
        confirmText: this.notificationEnum.notification_dialog_primary_btn,
        cancelText: this.notificationEnum.notification_dialog_secondary_btn,
      })
      .subscribe((res) => {
        if (res) {
          this.activityNotifyService
            .markAllasRead()
            .subscribe((resp: Response) => {
              if (resp.status == 200 || resp.status == 201) {
                this.userNotificationData = [];
                this.badgeCount = null;
                if (this.router.url.includes('notification')) {
                  this.navigateItem('notification');
                }
              } else {
                this.notificationService.showNotification(
                  this.notificationEnum.notification_notify_failed_body,
                  'error',
                  this.notificationEnum.notification_notify_failed_heading
                );
              }
            });
        }
      });
  }

  // user notification
  userNotification() {
    try {
      this.activityNotifyService.getNotification().subscribe((resp: any) => {
        if (resp != null) {
          resp.records.sort((a: any, b: any) => {
            return (
              new Date(b.eventDate).valueOf() - new Date(a.eventDate).valueOf()
            ); // descending
          });
          this.userNotificationData = resp.records.slice(0, 5);
          this.badgeCount = resp.matchingCount;
          this.cd.detectChanges();
        } else {
          this.userNotificationData = [];
          this.badgeCount = null;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  removeNotification(e: any) {
    try {
      let reqJson = {
        userID: e.userID,
        isRead: true,
        dateRead: e.dateRead,
        notificationID: e.notificationID,
      };
      this.activityNotifyService
        .updateNotificationStatus(reqJson)
        .subscribe((resp: any) => {
          if (resp.status == 200 || resp.status == 201) {
            this.userNotification();
            if (this.router.url.includes('notification')) {
              this.navigateItem('notification');
            }
          } else {
            this.notificationService.showNotification(
              this.notificationEnum.notification_notify_failed_body,
              'error',
              this.notificationEnum.notification_notify_failed_heading
            );
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  openTerms() {
    if (
      localStorage.getItem('authenticatedUser') != null &&
      localStorage.getItem('authenticatedUser') != undefined
    ) {
      this.permissionService.getPermissionListForUser().subscribe((res) => {
        if (res.body != undefined || res.body != null) {
          let authuserpermissions = res.body;
          if (authuserpermissions.user.termsAcceptedAt) {
            this.acceptedAt = authuserpermissions.user.termsAcceptedAt;
            this.MatDialog.open(TermsDialogComponent, {
              data: { acceptedAt: this.acceptedAt, action: false },
              disableClose: true,
              panelClass: 'custom-dialog',
            }).afterClosed();
          }
        }
      });
    }
  }
  openAbout() {
    this.isAboutDrawer = true;
  }
  closedrawer(event: any) {
    this.isAboutDrawer = false;
  }
  closeTerms() {
    this.MatDialog.closeAll();
  }
  // Redirect outside IDN
  redirectToSupport(): void {
    const link = this.supportLink;
    this.dialogService
      .confirmDialog({
        title: this.logoutEnum.redirect_dialog_heading,
        module: 'resources',
        message: this.logoutEnum.redirect_dialog_body,
        confirmText: this.logoutEnum.redirect_dialog_primary_btn,
        cancelText: this.logoutEnum.redirect_dialog_secondary_btn,
      })
      .subscribe((res: any) => {
        if (res) {
          window.open(link, '_blank');
        }
      });
  }

  onIframeLoad(){
    if (!this.loadEventProcessed) {
      this.loadEventProcessed = true;
    } else {
      this.loadEventProcessed = false;
      this.loaderService.hide();
    }
    setTimeout(()=>{
      this.loaderService.hide();
    },20000)
  }

  redirectToHome(){
    this.whatsNew = false;
  }

  toggleItems(path:any){
    for(let item in this.toggleMenuContainer){
      if(item == path){
        if(this.toggleMenuContainer[item]){
          this.toggleMenuContainer[item]=false;
        } else{
          this.toggleMenuContainer[item]=true;
        }
      } else{
        this.toggleMenuContainer[item]=false;
      }
    }
    localStorage.setItem('toggleMenuContainer', JSON.stringify(this.toggleMenuContainer));
  }

  closeReleaseBanner(){
    this.releaseLink = false;
    localStorage.setItem("WBReleaseLink", JSON.stringify(this.releaseLink));
  }

  // Redirect outside IDN
  redirectToAnnounceMents(): void {
    const link = "https://developer-help.icertis.com/#announcements";
    this.dialogService
      .confirmDialog({
        title: this.logoutEnum.redirect_dialog_heading,
        module: 'resources',
        message: this.logoutEnum.redirect_dialog_body,
        confirmText: this.logoutEnum.redirect_dialog_primary_btn,
        cancelText: this.logoutEnum.redirect_dialog_secondary_btn,
      })
      .subscribe((res: any) => {
        if (res) {
          window.open(link, '_blank');
        }
      });
  }

  openSite(siteUrl:any) {
    this.dialogService.confirmDialog({
      title: this.logoutEnum.redirect_dialog_heading,
      module: 'resources',
      message: this.logoutEnum.redirect_dialog_body,
      confirmText: this.logoutEnum.redirect_dialog_primary_btn,
      cancelText: this.logoutEnum.redirect_dialog_secondary_btn
    }).subscribe((res: any) => {
      if(res){
        window.open(siteUrl, '_blank');
      }
    });
 }
}
